import { Injectable } from '@angular/core';
import * as R from 'ramda';
import { Asset } from '@gelato-api-ui/core/designs/asset';
import { AssetMetadataService } from '@gelato-api-ui/core/designs/services/asset-metadata.service';
import { AssetsCollection } from '@gelato-api-ui/core/designs/assets-collection';
import { DesignStructure } from '@gelato-api-ui/core/designs/design-structure';
import { AssetProviderUid } from '@gelato-api-ui/core/designs/asset-provider-uid.enum';
import { getUsedAssets } from '@gelato-api-ui/core/designs/helpers/getUsedAssets';
import { EProductVariant } from '@gelato-api-ui/core/e-commerce/e-product-variant';

@Injectable({ providedIn: 'root' })
export class AssetContentIdsService {
  constructor(private readonly assetMetadataService: AssetMetadataService) {}

  getFromAsset(asset: Asset): string {
    return asset?.providerAssetId || this.assetMetadataService.getProviderAssetId(asset?.metadata);
  }

  getFromDesignStructure(
    assetsCollection: AssetsCollection,
    designStructure: DesignStructure,
    assetProviderUids: AssetProviderUid[],
  ): string[] {
    if (!assetsCollection || !designStructure || !assetProviderUids) {
      return [];
    }

    const assets: Asset[] = getUsedAssets(assetsCollection, designStructure);

    let ids: string[] = R.map((loopAsset: Asset): string => {
      if (!assetProviderUids.includes(loopAsset.assetProviderUid)) {
        return null;
      }

      return this.getFromAsset(loopAsset);
    }, assets);

    ids = R.filter((loopId: string): boolean => Boolean(loopId), ids);
    ids = R.sort((a, b) => a.localeCompare(b), ids);

    return R.uniq(ids);
  }

  getFromProductVariants(
    assetsCollection: AssetsCollection,
    productVariants: EProductVariant[],
    assetProviderUids: AssetProviderUid[],
  ): string[] {
    if (!assetsCollection || !productVariants || !productVariants.length) {
      return [];
    }

    let ids: string[] = [];

    productVariants.forEach((loopProductVariant: EProductVariant) => {
      if (!loopProductVariant.designStructureJson) {
        return;
      }

      let designData = null;

      try {
        designData = JSON.parse(loopProductVariant.designStructureJson);
      } catch (e) {}

      if (!designData) {
        return;
      }

      ids = [...ids, ...this.getFromDesignStructure(assetsCollection, designData, assetProviderUids)];
    });

    ids = R.sort((a, b) => a.localeCompare(b), ids);

    return R.uniq(ids);
  }
}
